import { webhookService } from '@services/api';
import { useQuery } from '@tanstack/react-query';

import { queryKeys } from '@/services/query.config';

import { operationRefetchInterval } from '../utils';

/** Polls a bulk retry operation every 2 s until it is done or failed. */
export function useWebhookOperation(organizationId: string, operationId: string, enabled: boolean) {
  return useQuery({
    queryKey: queryKeys.webhooks.operation(organizationId, operationId),
    // React Query rejects undefined data, hence null.
    queryFn: async () =>
      (
        await webhookService.getWebhookOperation({
          organization_id: organizationId,
          operation_id: operationId,
        })
      ).operation ?? null,
    enabled: enabled && !!organizationId && !!operationId,
    // Stop on error too, so a dispatcher outage does not poll forever.
    refetchInterval: query =>
      query.state.status === 'error'
        ? false
        : operationRefetchInterval(query.state.data ?? undefined),
    staleTime: 0,
    throwOnError: false,
  });
}
